import '@babel/polyfill'

const selectors = {
  modal: '[data-modal]',
  modalClose: '[data-modal-close]',
  modalOpen: '[data-modal-open]',
  modalLink: '[data-modal-link]',
  modalTab: '[data-modal-tab]',
  isActive: '-active'
}

export default () => {
  const modal = document.querySelector(selectors.modal)

  if (!modal) {
    return
  }

  const modalClose = modal.querySelector(selectors.modalClose)
  const modalLinks = modal.querySelectorAll(selectors.modalLink)

  const modalOpen = document.querySelectorAll(selectors.modalOpen)
  const modalTabs = document.querySelectorAll(selectors.modalTab)
  let type = null
  const requiredCheckboxes = document.querySelectorAll(".required-checkboxes")
  console.log(requiredCheckboxes)

  if(requiredCheckboxes){
    requiredCheckboxes.forEach(check => {
      check.addEventListener('change', (event) => {
        checkRequiredCheckboxes()
        console.log(checkRequiredCheckboxes())
      })
    })    
  }

  const checkRequiredCheckboxes = function () {
    return requiredCheckboxes.every(checkTrue)
  }
  const checkTrue = function (value, index, arr) {
    console.log(value.checked)
    if (index === 0){
      return true
    } else {
      return (value.checked === arr[index - 1].checked)
    }
  }
  //const enableSubmitButton

  const closeModal = function () {
    modal.classList.remove(selectors.isActive)
    Array.from(modalLinks).forEach(link => link.classList.remove(selectors.isActive))
    Array.from(modalTabs).forEach(tab => tab.classList.remove(selectors.isActive))

    const meta = modal.querySelector('[data-event-meta]')
    //const privateTab = modal.querySelector('[data-event-private]')
    //const companyTab = modal.querySelector('[data-event-company]')

    const data = document.querySelector('[data-event-modal="' + type + '"]')

    if (data) {
      data.appendChild(meta)
      //data.appendChild(privateTab)
      //data.appendChild(companyTab)
    }
  }

  const selectTab = function (index) {
    Array.from(modalLinks).forEach(link => link.classList.remove(selectors.isActive))
    modalLinks[index].classList.add(selectors.isActive)
    Array.from(modalTabs).forEach(tab => tab.classList.remove(selectors.isActive))
    modalTabs[index].classList.add(selectors.isActive)
  }

  modalClose.addEventListener('click', (e) => {
    e.preventDefault()
    closeModal()
  })

  Array.from(modalOpen).map(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault()
      type = el.dataset.modalOpen
      const data = document.querySelector('[data-event-modal="' + type + '"]')

      if (data) {
        const meta = data.querySelector('[data-event-meta]')
        /*const privateTab = data.querySelector('[data-event-private]')
        privateTab.querySelector('form input[type="hidden"]').value = type
        const companyTab = data.querySelector('[data-event-company]')
        companyTab.querySelector('form input[type="hidden"]').value = type*/
        //jQuery( '.start_date' ).val( meta.dataset.startDate ).trigger( 'change' )

        //console.log(modal.querySelectorAll('[data-modal-tab]'))
        modal.querySelector('[data-modal-meta]').innerHTML = ''
        modal.querySelector('[data-modal-meta]').appendChild(meta)
        //modal.querySelectorAll('[data-modal-tab]')[0].innerHTML = ''
        //modal.querySelectorAll('[data-modal-tab]')[0].appendChild(privateTab)
        //modal.querySelectorAll('[data-modal-tab]')[1].innerHTML = ''
        //modal.querySelectorAll('[data-modal-tab]')[1].appendChild(companyTab)
        modal.classList.add(selectors.isActive)
      }
    })
  })

  Array.from(modalLinks).map((link, index) => {
    link.addEventListener('click', e => {
      e.preventDefault()
      selectTab(index)
    })
  })
}
